
export default function AddAssetTypeDialogController(
  $scope,
  $rootScope,
  ssDialogService,
  loaderService,
  alerts,
  emDataService,
  assetDataService
) {
  const vm = this;

  vm.newAssetType = { ...vm.assetType };

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSubmit = _handleSubmit;

  _activate();

  /** *****************************************
   * Private Functions
   */

  function _activate() {
    let itAssetType = '';

    if (vm.assetType.isITAsset) {
      itAssetType = 'IT';
    } else {
      itAssetType = 'Non IT';
    }

    const isNew = vm.assetType.customerAssetTypeId < 0;

    if (isNew) {
      vm.title = `Add ${itAssetType} Asset Type`;
    } else {
      vm.title = `Edit ${itAssetType} Asset Type`;
    }
  }

  /** *****************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function _handleSubmit() {
    if ($scope.emAddAssetTypeForm.$invalid) {
      return Promise.resolve();
    }

    if ((vm.newAssetType.name === null) || (vm.newAssetType.name === '')) {
      return Promise.resolve();
    }

    loaderService.showViewLoader = true;

    return assetDataService.saveAssetType(vm.newAssetType).then((response) => {
      alerts.success('The Asset Type has been saved successfully.');

      let customerAssetTypeId = -1;

      if (vm.assetType.customerAssetTypeId < 0) {
        customerAssetTypeId = response.data.customerAssetTypeId;
      }

      if (vm.assetType.isITAsset) {
        $rootScope.$broadcast('refreshFunctionITAssets', {
          functionId: vm.functionId,
          customerAssetTypeId,
        });
      } else {
        $rootScope.$broadcast('refreshFunctionNonITAssets', {
          functionId: vm.functionId,
          customerAssetTypeId,
        });
      }
      _closeDialog();
    })
    .catch(() => {
      alerts.error('An error occurred while saving the Asset Type.');
    })
    .finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.addAssetTypeDialog);
  }
}

AddAssetTypeDialogController.$inject = [
  '$scope',
  '$rootScope',
  'ssDialogService',
  'loaderService',
  'alerts',
  'emDataService',
  'assetDataService'
];
